import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { createStore } from "./storeHelper";
import _ from "lodash";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:CollectionsStore`);

export const useCollectionsStore = defineStore(
  "collections",
  createStore({
    state: {
      collections: {},
    },

    getters: {
      collectionsList: (state) => _.values(state.collections),
      collectionById: (state) => (id) => state.collections[id],
    },

    actions: {
      async load() {
        debug("load");
        const collections = await ApiClient.get(`/collections`);
        debug("load", collections);
        this.set("collections", _.keyBy(collections, "id"));
      },
    },
  }),
);
